<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Arbeitstage - {{ userData?.firstName }} {{ userData?.lastName }} ({{ userData?.engagementTypeTranslation }})
        </h6>

        <CreateButton :label="$t('user.create')" :to="{ name: 'userForm' }"/>
      </div>

      <div class="element-box">
        <UserMenu :userId="userId" :employeeType="employeeType"/>

        <div class="row align-items-center justify-content-end mt-3">
          <button type="button" class="btn btn-outline-primary" @click="handleFormModal(null)">
            Arbeitstage hinzufügen
          </button>
        </div>

        <EmptyState
            v-if="!workingDays.data?.length"
            icon="fa-calendar-days"
            title="Keine Arbeitstage gefunden"/>

        <div v-else class="table-responsive overflow-auto pt-4">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th style="width: 8%; text-align: right">Jahr</th>
              <th style="width: 10%; text-align: right">Monat</th>
              <th style="width: 20%; text-align: right">Arbeitszeit im Monat</th>
              <th class="text-center">Arbeitstage</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in workingDays.data"
                :key="data.id"
                :class="['table-row']"
                @click="!isCoordinatorButNotHr && handleFormModal(data.id)">

              <td class="text-right">{{ data?.year }}</td>
              <td class="text-right">{{ data?.month }}</td>
              <td class="text-right">
                <strong class="js-lists-values-employee-name">
                  {{ data.planedHoursForMonth }} :
                  {{ data.planedMinutesForMonth === 0 ? '00' : data.planedMinutesForMonth }}
                </strong><br>
              </td>
              <td class="text-center">
                <strong class="js-lists-values-employee-name">
                  <template v-for="(day, index) in data.workingDaysArray" :key="index">
                    {{ day.date }} - {{ $t('general.weekDays.' + day.dayName) }}
                    <template v-if="index !== data.workingDaysArray.length - 1">
                      , &nbsp;
                    </template>
                    <template v-if="(index + 1) % 3 === 0">
                      <br>
                    </template>
                  </template>
                </strong>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Pagination
          v-if="workingDays?.pagination?.total_pages > 1"
          :totalPages="workingDays?.pagination?.total_pages"
          :currentPage="workingDays?.pagination?.current_page"
          :totalItems="workingDays?.pagination?.total_items"
          :perPage="workingDays?.pagination?.items_per_page"
          @pagechanged="getWorkingDays"/>
    </div>

    <Modal
        v-model="showModalForm"
        title="Qualifikationen"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-xl"
        :hide-footer="true"
        classFooter="justify-content-center">
      <Form :userId="userId"
            :workingDayId="workingDayId"
            :yearsDropdown="yearsDropdown"
            :monthsDropdown="enums.monthsInYear"
            v-model:submitForm="submitForm"/>
    </Modal>
  </PageTemplate>
</template>


<script setup>
import userService from '@/api/User';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { getYears } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Form from '@/views/App/User/StudentWorkingDays/Form.vue';
import UserMenu from '@/views/App/User/UserMenu.vue';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const { enums }             = piniaEnumsStore();
const route                 = useRoute();
const userId                = route.params.id;
const userData              = ref(null);
const workingDays           = ref([]);
const workingDayId          = ref(null);
const showModalForm         = ref(false);
const isLoaded              = ref(false);
const submitForm            = ref(false);
const isCoordinatorButNotHr = ref(false);
const yearsDropdown         = ref([]);
const employeeType          = ref("");

watch(submitForm, () => {
  showModalForm.value = false;
  workingDayId.value  = null;
  getWorkingDays();
});

async function getWorkingDays(page = 1, perPage, passedFilters) {
  CloseToast();
  try {
    const { data }    = await userService.getStudentWorkingDays(+userId);
    workingDays.value = data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getUser() {
  try {
    const { data } = await userService.getUser(+userId);
    userData.value = data.data.user;
    employeeType.value = data?.data?.user?.employeeType

  } catch (error) {
    await ErrorToast(error);
  }
}

function handleFormModal(id) {
  CloseToast();
  showModalForm.value = false;
  CloseToast();
  workingDayId.value  = id;
  showModalForm.value = true;
}

onMounted(async () => {
  await Promise.all([
    await getWorkingDays(),
    await getUser(),
    getYears(yearsDropdown),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>

</style>